import fn from "@/mixins/helpers"

let module = "users"
let Overview,
  OverviewCreate,
  OverviewEdit,
  View = null
let isMobile = fn.methods.$isMobile()

import UserList from "./components/List"

import UserQRCode from "./components/mobile/QRCode"
import QRCodeUserExpertise from "./components/partials/QRCodeUserExpertise"
import UserInfoQRCode from "./components/partials/QRCodeUserInfo"

OverviewCreate = () => import("./components/Overview")

if (!isMobile) {
  Overview = () => import("./components/Overview")
  OverviewEdit = () => import("./components/Overview")
  View = () => import("./components/View")
} else {
  Overview = () => import("./components/mobile/Overview")
  OverviewEdit = () => import("./components/mobile/OverviewEdit")
  View = () => import("./components/View")
}

export default [
  {
    path: "users",
    component: UserList,
    meta: { module: module, permissions: ["user-access"] },
  },
  {
    path: "users/account/create",
    component: OverviewCreate,
    props: true,
    meta: { module: module, permissions: ["user-create"] },
  },
  {
    path: "users/account/edit/:id",
    component: Overview,
    props: true,
    meta: { module: module, permissions: ["user-edit"] },
  },
  {
    path: "users/view/:id",
    component: View,
    props: true,
    meta: { module: module, permissions: ["all"] },
  },

  {
    path: "my/edit/:id",
    component: OverviewEdit,
    props: true,
    meta: { module: "my", permissions: ["user-edit"] },
  },
  {
    path: "my/qrcode/:id",
    component: UserQRCode,
    props: true,
    meta: { module: "my", permissions: ["all"] },
  },
  {
    path: "my/:id?",
    component: Overview,
    props: true,
    meta: { module: "my", permissions: ["all"] },
  },
  //{ path: 'course/accomplishment/:cid/:uid', component: AccomplishmentView, props: true, meta: { module: module, permissions: ["all"] }},

  {
    path: "qrcode/user/:id",
    component: UserInfoQRCode,
    props: true,
    meta: { module: module, permissions: ["all"] },
  },
  {
    path: "qrcode/user/:hash/expertise/:id",
    component: QRCodeUserExpertise,
    props: true,
    meta: { module: module, permissions: ["all"] },
  },
]
